import React, { useState } from "react";
import SchemaForm from "./components/SchemaForm.js";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  const [schemaType, setSchemaType] = useState("Article");
  const [schemaData, setSchemaData] = useState({});

  const handleSchemaChange = (type) => {
    setSchemaType(type);
    setSchemaData({});
  };

  const handleSchemaDataUpdate = (data) => {
    setSchemaData(data);
  };

  return (
    <div className="container mt-5">
     
      <div className="row">
        <div className="col-md-12">
          <SchemaForm
            schemaType={schemaType}
            onSchemaChange={handleSchemaChange}
            onSchemaDataUpdate={handleSchemaDataUpdate}
          />
        </div>
       
      </div>
    </div>
  );
}

export default App;
